import "../css/dailyReport.css";
import PageHeader from "../components/dailyReport/PageHeader";
import PartyFilter from "../components/dailyReport/PartyFilter";
import DateFilter from "../components/dailyReport/DateFilter";
import ActionButtons from "../components/dailyReport/ActionButtons";
import ExportButtons from "../components/dailyReport/ExportButtons";
import useCustomers from "../hook/useCustomers";
import { useEffect, useState } from "react";
import {
  getDailyLedgerReport,
  getDailyReports,
  getReportFromAPI,
} from "../services/reportService";
import { generateReport } from "../utils/report";
import LedgerTableCombined from "../components/common/LedgerTable";
import "../css/ledgertable.css";
import "../css/ledgertable2.css";
import "../css/ledgertable3.css";
import { encodeFilters } from "../components/filters/FilterUrl";

export default function DailyReports() {
  const { customers } = useCustomers();
  const [customer, setCustomer] = useState(null);
  const [fromDate, setFromDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);

  const [ledgerData, setLedgerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [originalData, setOrginalData] = useState();
  const [downloading, setDownloading] = useState(null);
  const [stats, setStats] = useState({});

  const [filters, setFilters] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const f = params.get("f") || "";
    const result = {};
    for (const token of f.split(",")) {
      if (!token.trim()) continue;
      const [key, charge] = token.split(":");
      result[key] = charge || true;
    }
    return result;
  });

  useEffect(() => {
    getReportData();
  }, [filters, customer]);

  // useEffect(() => {
  //   getReportData();
  // }, [customer]);

  async function getReportData() {
    try {
      setLoading(true);
      const response = await getDailyLedgerReport({
        customerId: customer?._id,
        from: fromDate,
        to: toDate,
        isDailyReport: true,
        f: encodeFilters(filters),
      });
      // console.log(response);

      if (response.success) {
        const transactions = response?.originalTransactions;
        const transformed = response?.transformedTransactions;
        setStats(response?.stats || {});
        setLedgerData(transformed);
        setOrginalData(transactions);
      }
      // console.log("Report data:", response);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  // const exportCSV = () => {
  //   const data = ledgerData;

  //   // RECEIVE
  //   const receiveRows = formatRows(data.receive.rows);
  //   const receiveCSV = convertToCSV(receiveRows);

  //   const receiveTotalRow = formatTotalsRow(data.receive.totals);
  //   const receiveTotalCSV = convertToCSV([receiveTotalRow]);

  //   // GIVEN
  //   const givenRows = formatRows(data.given.rows || []);
  //   const givenCSV = givenRows.length ? convertToCSV(givenRows) : "No Data";

  //   const givenTotalRow = formatTotalsRow(data.given.totals);
  //   const givenTotalCSV = convertToCSV([givenTotalRow]);

  //   // BALANCE
  //   const balanceRow = formatTotalsRow(data.balance);
  //   const balanceCSV = convertToCSV([balanceRow]);

  //   // FINAL CSV CONTENT
  //   const finalCSV = [
  //     receiveCSV,
  //     "",
  //     "TOTAL",
  //     receiveTotalCSV,
  //     "",

  //     givenCSV,
  //     "",
  //     "TOTAL",
  //     givenTotalCSV,
  //     "",
  //     balanceCSV,
  //   ].join("\n");

  //   download(finalCSV, `daily-report-${generateDateTime()}.csv`);
  // };

  // const exportExcel = () => {
  //   const generateExcel = (data) => {
  //     const wb = XLSX.utils.book_new();

  //     // RECEIVE
  //     const receiveData = formatRows(data.receive.rows);
  //     const ws1 = XLSX.utils.json_to_sheet(receiveData);
  //     XLSX.utils.book_append_sheet(wb, ws1, "Receive");

  //     // GIVEN
  //     const givenData = formatRows(data.given.rows);
  //     const ws2 = XLSX.utils.json_to_sheet(givenData);
  //     XLSX.utils.book_append_sheet(wb, ws2, "Given");

  //     // BALANCE (single row)
  //     const balanceData = [formatRows([data.balance])[0]];
  //     const ws3 = XLSX.utils.json_to_sheet(balanceData);
  //     XLSX.utils.book_append_sheet(wb, ws3, "Balance");

  //     XLSX.writeFile(wb, `daily-report-${generateDateTime()}.csv`);
  //   };
  //   generateExcel(ledgerData);
  // };

  const handlePrint = () => {
    const printContent = document.getElementById("report-section");

    const newWindow = window.open("", "", "width=1200,height=800");

    newWindow.document.write(`
    <html>
      <head>
        <title>Daily Report</title>
        <style>
          @page {
            size: A4 landscape;
            margin: 10mm;
          }

          body {
            font-family: Arial;
            zoom: 0.75;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 10px;
          }

          th, td {
            border: 1px solid #000;
            padding: 4px;
            text-align: center;
            white-space: nowrap;
          }

          h2 {
            margin-top: 20px;
          }
        </style>
      </head>
      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

    newWindow.document.close();
    newWindow.focus();

    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };

  // const exportPDF = async () => {
  //   const element = document.getElementById("pdf-wrapper");

  //   // SCALE DOWN TABLE FOR PDF
  //   element.style.transform = "scale(0.7)";
  //   element.style.transformOrigin = "top left";
  //   element.style.width = "1400px"; // important

  //   const canvas = await html2canvas(element, {
  //     scale: 2,
  //     useCORS: true,
  //   });

  //   // RESET STYLE AFTER CAPTURE
  //   element.style.transform = "scale(1)";
  //   element.style.width = "auto";

  //   const imgData = canvas.toDataURL("image/png");

  //   const pdf = new jsPDF("l", "mm", "a4");

  //   const pageWidth = 297;
  //   const pageHeight = 210;

  //   const imgWidth = pageWidth;
  //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //   let heightLeft = imgHeight;
  //   let position = 0;

  //   pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //   heightLeft -= pageHeight;

  //   while (heightLeft > 0) {
  //     position = heightLeft - imgHeight;
  //     pdf.addPage();
  //     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //     heightLeft -= pageHeight;
  //   }

  //   pdf.save(`daily-report-${generateDateTime()}.pdf`);
  // };

  // const downloadReport = async (type) => {
  //   try {
  //     const res = await getReportFromAPI({
  //       format: type,
  //       customerId: customer,
  //       from: fromDate,
  //       to: toDate,
  //     });

  //     const blob = new Blob([res.data], {
  //       type:
  //         type === "excel"
  //           ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //           : "text/csv",
  //     });

  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");

  //     a.href = url;
  //     a.download = `daily-report.${type === "excel" ? "xls" : type}`;

  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //   }
  // };

  const downloadReport = async (type) => {
    setDownloading(type);
    try {
      const isBinary = type !== "csv";

      const response = await getReportFromAPI(
        {
          format: type,
          customerId: customer,
          from: fromDate,
          to: toDate,
          f: encodeFilters(filters),
        },
        {
          responseType: isBinary ? "arraybuffer" : "text", // goes directly to axios
        },
      );

      const disposition = response.headers?.["content-disposition"];

      const headers = response.headers;

      let fileName = "report";

      if (disposition && disposition.includes("filename=")) {
        fileName = disposition.split("filename=")[1].replace(/"/g, "").trim();
      }

      const MIME_TYPES = {
        excel:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        csv: "text/csv;charset=utf-8;",
        pdf: "application/pdf",
      };
      const EXTENSIONS = { excel: "xlsx", csv: "csv", pdf: "pdf" }; // fix: xlsx not xls

      const blob = new Blob([response.data], { type: MIME_TYPES[type] });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || `daily-report.${EXTENSIONS[type]}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Error while downloading the file");
    } finally {
      setDownloading(null);
    }
  };

  const handleDateApply = () => {
    console.log("Apply date filter", { fromDate, toDate });
    console.log("Selected customer", customer);
    getReportData();
  };

  // console.log({ ledgerData });

  const handleClearDate = () => {
    setFromDate("");
    setToDate("");
    getReportData();
  };

  return (
    <>
      <PageHeader />

      <div className="container-fluid">
        <PartyFilter
          customers={customers}
          selectedCustomer={customer}
          setCustomer={setCustomer}
        />

        <DateFilter
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          handleDateApply={handleDateApply}
          handleClearDate={handleClearDate}
        />

        <ActionButtons editMode={editMode} setEditMode={setEditMode} />

        <ExportButtons
          exportCSV={() => downloadReport("csv")}
          exportExcel={() => downloadReport("excel")}
          exportPDF={() => downloadReport("pdf")}
          handlePrint={handlePrint}
          downloading={downloading}
        />

        <div id="pdf-wrapper">
          <div id="report-section">
            <LedgerTableCombined
              receiveRows={ledgerData?.receive?.rows || []}
              givenRows={ledgerData?.given?.rows || []}
              receiveTotals={ledgerData.receive?.totals || {}}
              givenTotals={ledgerData?.given?.totals || {}}
              balance={ledgerData?.balance || {}}
              stats={stats}
              loading={loading}
              editMode={editMode}
              originalData={originalData}
              refresh={getReportData}
              isDailyReport={true}
              setFilters={setFilters}
            />
            {/* <LedgerTable
              rows={ledgerData?.receive?.rows || []}
              totals={}
              balance={ledgerData?.balance}
              loading={loading}
              type="receive"
              editMode={editMode}
              originalData={originalData}
              refresh={getReportData}
            />

            <LedgerTable
              rows={ledgerData.given?.rows || []}
              totals={ledgerData.given?.totals}
              balance={ledgerData?.balance}
              loading={loading}
              type="given"
              editMode={editMode}
              originalData={originalData}
              refresh={getReportData}
            /> */}
          </div>
        </div>

        {/* <SubmitSection /> */}
      </div>

      <div id="sidebarOverlay" />
    </>
  );
}
